module.exports = __webpack_public_path__ + "fonts/Inter-Italic.f92312f.woff?v=1744194310396";